import {
    DataTexture,
    RGBAFormat,
    LogLuvEncoding,
    LinearMipmapLinearFilter,
    LinearFilter,
    RepeatWrapping,
    UVMapping,
    ClampToEdgeWrapping,
    SphericalReflectionMapping
} from "three";
var zlib = window.Zlib;
class EnvironmentPanorama {
    constructor(urlOrData, size, options) {
        this._options = options || {};
        this._size = size;
        if (typeof urlOrData === 'string') this._file = urlOrData;
        else this._data = urlOrData;

    }
    getFile() {
        return this._file;
    }
    isGunzipBuffer(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        return typedArray[0] === 0x1f && typedArray[1] === 0x8b;
    };
    gunzip(arrayBuffer) {
        var typedArray = new Uint8Array(arrayBuffer);
        // var zlib = require('zlib');
        if (!zlib) {
            console.error('zlib is not exit')
        }
        var zdec = new zlib.Gunzip(typedArray);
        var result = zdec.decompress();
        return result.buffer;
    }
    deinterleaveImage4(size, src, dst) {
        var npixel = size * size;
        var npixel2 = 2 * npixel;
        var npixel3 = 3 * npixel;
        var idx = 0;
        for (var i = 0; i < npixel; i++) {
            dst[idx++] = src[i];
            dst[idx++] = src[i + npixel];
            dst[idx++] = src[i + npixel2];
            dst[idx++] = src[i + npixel3];
        }
    }
    createRGBA8Packed() {

        var size0 = this._size;
        var texture = new DataTexture(this._packedImages, size0, size0, RGBAFormat);
        var envMap = texture;
        envMap.format = RGBAFormat;
        envMap.generateMipmaps = true;
        // envMap.mipmaps = [];
        // envmap.minFilter=THREE.LinearFilter;
        envMap.flipY = true;
        envMap.minFilter = LinearFilter;
        envMap.magFilter = LinearFilter;
        envMap.wrapS = RepeatWrapping;
        envMap.wrapT = RepeatWrapping;
        envMap.encoding = LogLuvEncoding;
        envMap.mapping = UVMapping;
        envMap.needsUpdate = true;
        this.envMap = envMap;
        return envMap;

    }
    loadPacked() {
        let self = this;
        var readInputArray = function (inputArray) {
            var data = inputArray;
            if (self.isGunzipBuffer(data))
                data = self.gunzip(data);
            var size = self._size;
            var imageData, deinterleave;
            imageData = new Uint8Array(data);
            deinterleave = new Uint8Array(data.byteLength);
            self.deinterleaveImage4(size, imageData, deinterleave);
            imageData = deinterleave;
            self._packedImages = imageData;

            return self.createRGBA8Packed();


        }
        return readInputArray(this._data);
    }

}
export default EnvironmentPanorama